// Logik der Seitenleiste: sichtbare Seiten je Programm (nach Rechten) und der gemerkte Eingeklappt-Zustand.
import { useEffect, useState } from "react";
import { useSitzung } from "../kern/sitzung";
import { PROGRAMME, seitenImProgramm, type ProgrammId, type Seite } from "../navigation/katalog";

/** Seiten eines Programms, die der Benutzer sehen darf. */
export function useSichtbareSeiten() {
  const { darfEines } = useSitzung();
  const erlaubt = (s: Seite) => s.rechte.length === 0 || darfEines(s.rechte);
  const seitenVon = (p: ProgrammId) => seitenImProgramm(p).filter(erlaubt);
  // ein Programm erscheint, wenn eine seiner Seiten ein eigenes Recht verlangt, das der Benutzer hat
  const programme = PROGRAMME.filter((p) => seitenVon(p.id).some((s) => s.rechte.length > 0));
  return { seitenVon, programme };
}

const EINGEKLAPPT = "imNavEingeklappt";
const imEingabefeld = (e: KeyboardEvent) => {
  const el = e.target as HTMLElement | null;
  return !!el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));
};

/** Eingeklappt-Zustand (gemerkt je Browser) mit Taste [. */
export function useEingeklappt(): [boolean, (x: boolean) => void] {
  const [eingeklappt, setEingeklappt] = useState(() => { try { return localStorage.getItem(EINGEKLAPPT) === "ja"; } catch { return false; } });
  useEffect(() => {
    try { localStorage.setItem(EINGEKLAPPT, eingeklappt ? "ja" : "nein"); } catch { /* ohne Speicher geht es auch */ }
  }, [eingeklappt]);
  useEffect(() => {
    const taste = (e: KeyboardEvent) => {
      if (e.key === "[" && !e.metaKey && !e.ctrlKey && !e.altKey && !imEingabefeld(e)) setEingeklappt((x) => !x);
    };
    // Taste [ in der eingebetteten Website: kommt über den gemeinsamen Speicher beim Rahmen an
    const speicher = (e: StorageEvent) => { if (e.key === EINGEKLAPPT) setEingeklappt(e.newValue === "ja"); };
    window.addEventListener("keydown", taste);
    window.addEventListener("storage", speicher);
    return () => { window.removeEventListener("keydown", taste); window.removeEventListener("storage", speicher); };
  }, []);
  return [eingeklappt, setEingeklappt];
}
